export default "__VITE_ASSET__DShDUNI3__"